import { MailCheck, MailX } from 'lucide-react';

import { Badge } from '@virtual-care/shadcn';

export function EmailVerifiedBadge({ verified }: { verified: boolean }) {
  if (verified) {
    return (
      <Badge className="gap-1 bg-green-100 text-green-800 hover:bg-green-100">
        <MailCheck className="size-3" />
        Verified
      </Badge>
    );
  }
  return (
    <Badge className="gap-1 bg-gray-100 text-gray-600 hover:bg-gray-100">
      <MailX className="size-3" />
      Not Verified
    </Badge>
  );
}
